import Vue from "vue";
import VueRouter from "vue-router";
import layoutVue from "../layout/layout.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: layoutVue,
    redirect: "/Home",
    children: [
      {
        path: "/Home",
        name: "home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "/About",
        name: "about",
        component: () => import("../views/About.vue"),
      },
      {
        path: "/Business",
        name: "business",
        component: () => import("../views/Business.vue"),
      },
      {
        path: "/News",
        name: "news",
        component: () => import("../views/News.vue"),
      },
      // SEO：路径型URL，爬虫访问时由nginx转发到后端渲染页
      {
        path: "/news/:id",
        name: "newsDetail",
        component: () => import("../views/NewsDetails.vue"),
      },
      {
        path: "/Contact",
        name: "contact",
        component: () => import("../views/Contact.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
